module.exports = __webpack_public_path__ + "img/TINTURASMADRE.3195028a.png";